import all from './all';
import providerTypeDetail from './providerTypeDetail';
import editProviderTypeDetail from './editProviderTypeDetail';
import getSubtype from './getSubtype';

export default {
  all,
  providerTypeDetail,
  editProviderTypeDetail,
  getSubtype,
};
